import React from "react";
import { TextInput } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";

const EmailFromAddressInput = ({
  sendDomain,
}) => {
  const {
    sendDomainModified,
  } = useMarketingSettingsContext();

  const handleChange = (e) => {
    e.preventDefault();

    sendDomainModified({ ...sendDomain, from_address: e.target.value });
  };

  return (
    <TextInput
      label="Email from address"
      placeholder="hello"
      type="text"
      onChange={handleChange}
      value={sendDomain.from_address || ""}
      trailingText={`@${sendDomain.domain || "yourvenue.com"}`}
    />
  );
};

export default EmailFromAddressInput;
